import { projectQualityForVideoResolution } from '../../videoResolutionProjectQuality'

/** Display labels never replace the resolution stored or sent to a provider. */
export function getVideoResolutionDisplayName(model: string, resolution: string): string {
  const displayResolution = projectQualityForVideoResolution(model, resolution)
  return displayResolution === 'auto'
    ? 'Auto'
    : displayResolution === '4k'
      ? '4K'
      : displayResolution
}
